import { CS } from "../../../../../base/utils/styler";

export const baseStyle: CS = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 8fr',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '30px'
}

export const linkStyle: CS = {
    cursor: 'pointer',
    marginRight: '100px',
    '&:hover': {
        opacity: '.5'
    }
}

export const inputStyle: CS = {
    padding: '10px',
    border: '1px solid #d9d9d9',
    borderRadius: '10px',
    boxSizing: 'border-box',
    fontSize: '16px',
    textAlign: 'left',
    direction: 'ltr',
}

export const titleStyle: CS = {
    paddingTop: '5px',
    fontSize: '16px',
}